
export const view = {
  INTERNAL: 'internal',
  EXTERNAL: 'external'
}

export const USER_FORM_DELAY_MS = 5000

export const buildingType = {
  I: 'I',
  L: 'L',
  D: 'D',
  H: 'H',
  O: 'O',
  T: 'T'
}